export default __webpack_public_path__ + "static/media/holeInOneAward.a608b665.svg";